// @ts-nocheck
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import { Link as RouterLink } from 'react-router-dom';
import { renderDate } from 'utils/helpers';

const getStatusLabel = (status) => {
    if (status === 'pending') {
        return 'Afventer accept';
    }

    if (status === 'accepted') {
        return 'Accepteret';
    }

    return 'Ophævet';
};

const flattenScopes = (sharing) => {
    if (!sharing?.requestedScopes?.length) {
        return '';
    }

    return sharing.requestedScopes
        .map((scope) => Object.keys(scope || {}).filter((key) => key !== 'type').join(' '))
        .join(' ');
};

const matchesSharingSearch = (sharing, search) => {
    const term = search.trim().toLowerCase();

    if (!term) {
        return true;
    }

    const values = [
        getStatusLabel(sharing?.status),
        sharing?.exporter?.name,
        sharing?.exporter?.email,
        sharing?.sharingId,
        flattenScopes(sharing),
    ]
        .filter(Boolean)
        .map((value) => String(value).toLowerCase());

    return values.some((value) => value.includes(term));
};

const SharingsTable = ({ sharings, getSharingPath }) => {
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);

    const filteredSharings = useMemo(
        () => sharings.filter((sharing) => matchesSharingSearch(sharing, search)),
        [sharings, search],
    );

    useEffect(() => {
        setPage(0);
    }, [filteredSharings.length]);

    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const pagedSharings = filteredSharings.slice(startIndex, endIndex);

    return (
        <>
            <Box sx={{ mb: 2 }}>
                <TextField
                    size="small"
                    placeholder="Søg delinger..."
                    value={ search }
                    onChange={ (event) => setSearch(event.target.value) }
                    autoComplete="off"
                    sx={{
                        width: 360,
                        backgroundColor: 'white',
                        borderRadius: 1,
                        paddingLeft: 1,
                        paddingRight: 1,
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: 'rgba(0, 0, 0, 0.23)',
                            },
                            '&:hover fieldset': {
                                borderColor: 'rgba(0, 0, 0, 0.87)',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: 'primary.main',
                            },
                        },
                    }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                />
            </Box>
            <TableContainer>
                <Table caria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">Status</TableCell>
                            <TableCell align="left">Navn / Email</TableCell>
                            <TableCell align="left">Dato</TableCell>
                            <TableCell align="left"></TableCell>
                            <TableCell />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        { pagedSharings.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={ 5 } align="center">Ingen delinger matcher søgningen.</TableCell>
                            </TableRow>
                        ) }
                        { pagedSharings.map((sharing) => (
                            <TableRow key={ sharing.sharingId }>

                                { (sharing.status === 'pending' && (
                                    <>
                                        <TableCell align="left">Afventer accept</TableCell>
                                        <TableCell align="left">{ sharing.exporter.email }</TableCell>
                                        <TableCell align="left">Anmodet dato: { renderDate(sharing.createdAt) }</TableCell>
                                    </>
                                )) || (sharing.status === 'accepted' && (
                                    <>
                                        <TableCell align="left">Accepteret</TableCell>
                                        <TableCell align="left">{ sharing.exporter.name }</TableCell>
                                        <TableCell align="left">Udløber dato: { renderDate(sharing.expiry) }</TableCell>
                                    </>
                                )) || (
                                    <>
                                        <TableCell align="left">Ophævet</TableCell>
                                        <TableCell />
                                        <TableCell align="left">Ophævet dato: { renderDate(sharing.updatedAt) }</TableCell>
                                    </>
                                ) }
                                <TableCell align="left"></TableCell>
                                <TableCell sx={{ p: 0 }} align="right">
                                    <Button component={ RouterLink } to={{ pathname: getSharingPath(sharing.sharingId) }} variant="contained">Åben</Button>
                                </TableCell>
                            </TableRow>
                        )) }
                    </TableBody>
                </Table>
                <TablePagination
                    component="div"
                    count={ filteredSharings.length }
                    page={ page }
                    rowsPerPage={ rowsPerPage }
                    labelRowsPerPage="Rækker pr. side"
                    onPageChange={ (event, newPage) => setPage(newPage) }
                    onRowsPerPageChange={ (event) => {
                        setRowsPerPage(Number(event.target.value));
                        setPage(0);
                    } }
                    rowsPerPageOptions={ [10, 25, 50] }
                />
            </TableContainer>
        </>
    );
};


SharingsTable.propTypes = {
    sharings: PropTypes.array.isRequired,
    getSharingPath: PropTypes.func.isRequired,
};

export default SharingsTable;
